class Warning extends Error {
  constructor(message, options) {
    super(message, options);
    Object.setPrototypeOf(this, Warning.prototype);
    this.name = "Warning";
  }
  static isWarning(warning) {
    return warning instanceof Warning;
  }
}

export { Warning };
//# sourceMappingURL=warning.js.map
